import { render, staticRenderFns } from "./DreamDeleteModal.vue?vue&type=template&id=ef058b1c&"
import script from "./DreamDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./DreamDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./DreamDeleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports